import { useEffect, useState, useRef } from "react";
import { getPartidoTV } from "../../../services/getPartidoTV";
import { hasGameStarted } from "../ligaTV/cardPartido/statusHelpers";
import TeamPartido from "./TeamPartido";
import Loading from "../../loading/loading";
import marker from "../../../assets/w-tv/marker-02.png";
import logoDefault from "../../../assets/escudo-default-foot.png";
import "./partidoTV.sass";
import TickerClarosportsPage from "../../../pages/tickerClarosports";

export default function PartidoTV({ match }) {
  const [game, setGame] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isRefreshing, setIsRefreshing] = useState(false);

  const refreshIntervalRef = useRef(null);
  const hasLoadedRef = useRef(false);

  // Función para cargar el partido
  const fetchPartidoData = async (showLoading = true) => {
    if (!match) {
      setError("No se proporcionó el ID del partido");
      if (showLoading) setLoading(false);
      return;
    }

    try {
      if (showLoading) setLoading(true);
      else setIsRefreshing(true);

      const { data, statusCode } = await getPartidoTV(match);

      if (statusCode === 200) {
        setGame(data);
        setError(null);
      } else {
        setError(`Error: ${statusCode}`);
        setGame(null);
      }
    } catch (err) {
      setError(err.message || "Error desconocido");
      setGame(null);
    } finally {
      if (showLoading) setLoading(false);
      else setIsRefreshing(false);
    }
  };

  // Cargar datos iniciales y configurar refresh automático
  useEffect(() => {
    // Evitar ejecución duplicada
    if (hasLoadedRef.current) {
      return;
    }

    const loadInitialData = async () => {
      hasLoadedRef.current = true;

      // Cargar datos iniciales (con loading)
      await fetchPartidoData(true);

      // Configurar actualización automática cada 60 segundos (60000 ms)
      // Sin mostrar loading para evitar saltos visuales
      refreshIntervalRef.current = setInterval(async () => {
        try {
          await fetchPartidoData(false);
        } catch (err) {
          console.error("Error en el refresh automático del partido:", err);
        }
      }, 60000);
    };

    loadInitialData();

    // Cleanup al desmontar el componente
    return () => {
      if (refreshIntervalRef.current) {
        clearInterval(refreshIntervalRef.current);
      }
    };
  }, [match]);

  if (loading) return <div className="partido-tv-container loading"><Loading type={"1080px"} /></div>;

  // Extraer datos del partido si existen
  const {
    left_name = "Local",
    left_image = logoDefault,
    left_score = "-",
    left_class = "",
    right_name = "Visitante",
    right_image = logoDefault,
    right_score = "-",
    right_class = "",
    period_title = "Por comenzar",
    venue_name = "Por definir",
    liga = "Liga",
    league_image = logoDefault,
    class: gameClass = ""
  } = game || {};

  // Determinar si el partido ha comenzado
  const started = game ? hasGameStarted(gameClass) : false;

  return (
    <div className="partido-wrapper">
      <div className={`partido-tv-container ${isRefreshing ? 'refreshing' : ''}`}>
        {!game ? (
          <div className="error-message">No se encontraron datos del partido</div>
        ) : (
          <>
            {error
              ? <p>No se encontraron datos del partido</p>
              :
              <>
                {/* Header del partido */}
                <div className="partido-header">
                  <div className="partido-info">
                    <img className="" src={league_image} />
                    <h1 className="game-name">{liga}</h1>
                  </div>
                </div>

                {/* Contenedor principal del partido */}
                <div className="partido-main">
                  {/* Team Local */}
                  <TeamPartido
                    name={left_name}
                    image={left_image}
                    statusClass={left_class}
                    position="left"
                  />

                  {/* Divisor */}
                  <div className="vs-divider">
                    {started ? (
                      <div className="vs-divider-score">
                        <span className="score-vs">{left_score}</span>
                        <span className="vs-text">-</span>
                        <span className="score-vs">{right_score}</span>
                      </div>
                    ) : (
                      <span className="vs-text">VS</span>
                    )}
                    <span className="period-title-divider">{period_title}</span>
                  </div>

                  {/* Team Visitante */}
                  <TeamPartido
                    name={right_name}
                    image={right_image}
                    statusClass={right_class}
                    position="right"
                  />
                </div>

                {/* Footer - Información del estadio */}
                <div className="partido-footer">
                  <span className="venue">{venue_name}</span>
                </div>

                <div className="qr-partido">
                  <img src={marker} alt="marker" />
                </div>
              </>
            }
          </>
        )}
      </div>

      <TickerClarosportsPage />
    </div>
  );
}